module.exports = __webpack_public_path__ + "static/media/xwf_retailers.a6df7cc2.csv";